import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { fetchServices } from 'modules/common/actions/fetchServices';
import { getServicesWithDescription } from 'modules/queues/Schedule/selectors/appointmentsFilters';
import { setFilterByServices as setFilter } from 'modules/queues/Schedule/actions/appointmentsFilters';
import FilterByService from './FilterByService';


const mapStateToProps = (state, ownProps) => {
  const { services, description } = getServicesWithDescription(state, ownProps);
  const { status } = state.common.services;
  const servicesPending = status === requestsStatuses.pending;

  return {
    servicesPending,
    services,
    description,
  };
};


export default compose(
  injectIntl,

  connect(
    mapStateToProps,
    { setFilter, fetchServices },
  ),

  lifecycle({
    componentDidMount() {
      this.props.fetchServices();
    },
  }),
)(FilterByService);
